import { create } from 'zustand';

export interface SSSiteSummaryFilterObject {
	ss_code: string;
}

export interface SiteSummaryListingStore {
	allSSSiteSummaryFilter: SSSiteSummaryFilterObject;
	updateFilter: (filterObject: SSSiteSummaryFilterObject) => void;
	resetSiteSummaryFilter: () => void;
}

const initialState: { allSSSiteSummaryFilter: SSSiteSummaryFilterObject } = {
	allSSSiteSummaryFilter: {
		ss_code: '',
	},
};

export const useSsSiteSummaryListingStore = create<SiteSummaryListingStore>((set) => ({
	...initialState,
	updateFilter: (filterObject): void => {
		set((state) => ({
			...state,
			allSSSiteSummaryFilter: { ...state.allSSSiteSummaryFilter, ...filterObject },
		}));
	},
	resetSiteSummaryFilter: (): void => {
		set((state) => ({
			...state,
			allSSSiteSummaryFilter: {
				ss_code: '',
			},
		}));
	},
}));
